module.exports = __webpack_public_path__ + "static/media/bookiconhover.bdebdd59.svg";